import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { getChangelog } from "@/lib/api";

const Release = ({ r, isCurrent }) => (
  <div className="border-l-2 border-bt-border-subtle pl-4 pb-6 last:pb-0" data-testid={`changelog-release-${r.version}`}>
    <div className="flex items-center gap-2 flex-wrap">
      <span className="font-mono text-sm text-bt-gold font-semibold">{r.version}</span>
      {isCurrent && (
        <span className="font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 bg-bt-gold text-bt-bg" data-testid="changelog-current-badge">Current</span>
      )}
      <span className="font-mono text-[11px] text-bt-text-tertiary">{r.date}</span>
    </div>
    <p className="font-body text-sm text-bt-text-primary font-medium mt-1">{r.title}</p>
    <ul className="mt-2 space-y-1">
      {r.changes.map((c, i) => (
        <li key={i} className="font-body text-xs text-bt-text-secondary leading-relaxed flex gap-2">
          <span className="text-bt-gold">•</span><span>{c}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const ChangelogDialog = ({ open, onOpenChange }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (open && !data) getChangelog().then(r => setData(r.data)).catch(() => setData({ releases: [] }));
  }, [open, data]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-bt-surface border-bt-border-subtle max-w-lg max-h-[80vh] overflow-y-auto" data-testid="changelog-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-bt-text-primary">Release Notes</DialogTitle>
          <DialogDescription className="font-body text-xs text-bt-text-tertiary">Every change to Rockafeller Jones, newest first.</DialogDescription>
        </DialogHeader>
        <div className="mt-2" data-testid="changelog-list">
          {!data && <p className="font-mono text-xs text-bt-text-tertiary">Loading…</p>}
          {data?.releases.map(r => <Release key={r.version} r={r} isCurrent={r.version === data.current} />)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
